import * as React from 'react'
import {IAppUser} from '../../interfaces/reducers'
import {nls} from '../nls'

interface Props {
  mobile: boolean
  user?: IAppUser
  onLogout?: () => void
}

const AppHeader = (props: Props) => {
  return (
    <div className="app-header disable-select">
      <div className="header-title-and-logo">
        <img src="resources/icons/logo.png" width={40} height={40} style={{height: '40px'}} alt="" />
        <div style={{display: 'flex', flexDirection: 'column', margin: '0px 30px'}}>
          <span>{nls.app.title}</span>
          {props.mobile ? null : <span style={{fontSize: '14px'}}>{nls.app.subTitle}</span>}
        </div>
      </div>
      {props.user ? (
        <div
          style={{
            position: 'relative',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div style={{marginRight: '10px', fontSize: '15px'}}>{`Здравей, ${props.user.username}`}</div>
          <div title="Изход" style={{fontSize: '30px', cursor: 'pointer'}} onClick={props.onLogout}>
            <i className="fas fa-sign-out-alt" />
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default AppHeader
